import {
  SearchDisplayItemMasterRequest,
  DetailDisplayItemMasterRequest,
  UpdateDisplayItemMasterRequest,
  DeleteDisplayItemMasterRequest,
  CopyDisplayItemMasterRequest,
  UserListDisplayItemMasterRequest,
  SearchDisplayItemMasterResponse,
  SearchDisplayItemMasterRecord,
  DetailDisplayItemMasterResponse,
  UserListDisplayItemMasterResponse,
  UserListDisplayItemMasterRecord,
  ScreenListDisplayItemMasterResponse,
} from 'api-types/src/types/display-item-master';
import { createSlice } from '@reduxjs/toolkit';
import i18n from 'i18n/i18n';

type MenuItemSearchState = {
  dataSearch: SearchDisplayItemMasterRecord[];
  total: number;
  loading: boolean;
  message: string;
  maintenanceList: DetailDisplayItemMasterResponse | {};
  screenList: { value: string; label: string }[];
  success: boolean;
  excelFile: string | null;
  userIdListForCopy: UserListDisplayItemMasterRecord[];
  loadingCopy: boolean;
  userId: string;
  dataSearchAll: boolean;
};

const initialState: MenuItemSearchState = {
  dataSearch: [],
  total: 0,
  loading: false,
  message: '',
  maintenanceList: {},
  screenList: [],
  success: false,
  excelFile: null,
  userIdListForCopy: [],
  loadingCopy: false,
  userId: '',
  dataSearchAll: false,
};

export const menuDisplayItemSlice = createSlice({
  name: 'menuDisplayItem',
  initialState,
  reducers: {
    checkExistMenuItem: (state, action: { payload: SearchDisplayItemMasterRequest }) => {},
    checkExistMenuItemSuccess: (state, action: { payload: SearchDisplayItemMasterResponse }) => {
      if (!action?.payload?.total) {
        state.dataSearchAll = true;
      } else {
        state.dataSearchAll = false;
      }
    },
    getListMenuDisplayItem: (state, action: { payload: SearchDisplayItemMasterRequest }) => {
      state.loading = true;
    },
    getListMenuDisplayItemSuccess: (state, action: { payload: SearchDisplayItemMasterResponse }) => {
      state.dataSearch = action?.payload?.records;
      state.total = action?.payload?.total;
      if (action?.payload?.records.length) {
        state.message = '';
      } else {
        state.message = i18n.t('message.common.0001');
      }

      state.loading = false;
    },
    getListMenuDisplayItemFailure: (state, action) => {
      state.loading = false;
    },
    getDetailMenuItem: (
      state,
      action: {
        payload: DetailDisplayItemMasterRequest & {
          onGetDataSuccess: () => void;
          onGetDataFail: () => void;
        };
      }
    ) => {},
    getDetailMenuItemSuccess: (state, action: { payload: DetailDisplayItemMasterResponse }) => {
      state.maintenanceList = action.payload;
    },

    updateDetailMenuItem: (
      state,
      action: {
        payload: UpdateDisplayItemMasterRequest & {
          onUpdateSuccess: () => void;
          onUpdateFail: () => void;
        };
      }
    ) => {},
    deleteDetailMenuItem: (
      state,
      action: {
        payload: DeleteDisplayItemMasterRequest & {
          onDeleteSuccess: (data: any) => void;
          onDeleteFail: (error: any) => void;
        };
      }
    ) => {},
    handleGetListScreenRequest: (state) => {
      return {
        ...state,
      };
    },
    handleGetListScreenResponse: (state, action: { payload: ScreenListDisplayItemMasterResponse }) => {
      const { payload } = action;
      const list = payload?.map((screen) => {
        return {
          value: screen.SCREEN_ID,
          label: `${screen.SCREEN_ID} : ${screen.SCREEN_NM}`,
        };
      });
      return {
        ...state,
        screenList: list,
      };
    },
    registerMenuDisplay: (
      state,
      action: {
        payload: UpdateDisplayItemMasterRequest & {
          onRegisterFail: () => void;
        };
      }
    ) => {
      state.success = false;
    },
    registerMenuDisplaySuccess: (state, action) => {
      state.success = true;
    },
    registerMenuDisplayFailure: (state, action) => {
      state.success = false;
      state.message = action.payload.message;
    },

    exportExcelItemDisplay: (state, action: { payload: SearchDisplayItemMasterRequest }) => {},
    exportExcelItemDisplaySuccess: (state, action: { payload: string }) => {
      state.excelFile = action.payload;
    },
    getUserIdForCopyData: (state, action: { payload: UserListDisplayItemMasterRequest }) => {},
    getUserIdForCopyDataSuccess: (state, action: { payload: UserListDisplayItemMasterResponse }) => {
      state.userIdListForCopy = action.payload.records;
    },
    handleCopyItemDisplayRequest: (
      state,
      action: { payload: { data: CopyDisplayItemMasterRequest; onSuccess: () => void } }
    ) => {
      return {
        ...state,
        loadingCopy: true,
      };
    },
    handleCopyItemDisplayResponse: (state, action) => {
      return {
        ...state,
        loadingCopy: false,
      };
    },
    cleanData: (state, action) => {
      return {
        ...state,
        ...initialState,
        userId: action.payload.userId || '',
        dataSearchAll: action.payload.dataSearchAll || false,
      };
    },
    getUserID: (state, action) => {
      state.userId = action.payload;
    },
  },
});

export const {
  getListMenuDisplayItem,
  getListMenuDisplayItemSuccess,
  getListMenuDisplayItemFailure,
  getDetailMenuItem,
  getDetailMenuItemSuccess,
  registerMenuDisplay,
  registerMenuDisplaySuccess,
  registerMenuDisplayFailure,
  updateDetailMenuItem,
  deleteDetailMenuItem,
  handleGetListScreenRequest,
  handleGetListScreenResponse,
  exportExcelItemDisplay,
  getUserIdForCopyData,
  exportExcelItemDisplaySuccess,
  getUserIdForCopyDataSuccess,
  handleCopyItemDisplayResponse,
  handleCopyItemDisplayRequest,
  cleanData,
  getUserID,
  checkExistMenuItem,
  checkExistMenuItemSuccess,
} = menuDisplayItemSlice.actions;

export default menuDisplayItemSlice.reducer;
